module.exports = __webpack_public_path__ + "img/cashier.2bd013bd.png";